import { Component, ViewChild, TemplateRef, OnInit } from '@angular/core';
import {DataTableColumn, PaginatorStatus, SortConfiguration} from '../../generics/data-table/data-table.component';
import { CustomTableFilter } from '../../generics/table-filter/table-filter.component';
import { ExchangeRate } from 'src/app/models/exchange-rate.model';
import { UtilsService } from 'src/app/services/utils.service';
import { ExchangeRateService } from 'src/app/services/exchange-rate.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ErrorResponse } from 'src/app/models/error.model';
import { PageEvent } from '@angular/material/paginator';
import { SelectOption } from 'src/app/models/select-option.model';
import {ChangeEmailDialogComponent} from '../../../dialogs/change-email-dialog/change-email-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import { NewExchangeRateDialogComponent } from 'src/app/dialogs/new-exchange-rate-dialog/new-exchange-rate-dialog.component';
import { Currency } from 'src/app/models/currency.model';

@Component({
  selector: 'app-exchange-rate',
  templateUrl: './exchange-rate.component.html',
  styleUrls: ['./exchange-rate.component.scss']
})
export class ExchangeRateComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
        buttonsColumnTeplate: TemplateRef<any>;

    paginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    exchangeRateFG = new FormGroup({
        codigoMonedaBase: new FormControl<string | undefined>('USD', []),
        codigoMonedaCambio: new FormControl<string | undefined>('ARS', []),
    });

    sortConfiguration?: SortConfiguration;

    exchangeRates?: ExchangeRate[];

    columns: DataTableColumn[] = [
        { name: 'Código moneda base', prop: 'codigoMonedaBase', sortable: true },
        { name: 'Código moneda cambio', prop: 'codigoMonedaCambio', sortable: true },
        { name: 'Fecha', prop: 'fecha', sortable: true, },
        { name: 'Tipo de cambio', parseValue: (exchangeRate: ExchangeRate) => this.esEntero(exchangeRate.cambio), sortable: true, },
        { name: '', width: '130px' }
    ];

    filters: CustomTableFilter[] = [
        { key: 'codigoMonedaBase', description: 'Código moneda base', type: 'STRING' },
        { key: 'codigoMonedaCambio', description: 'Código moneda cambio', type: 'STRING' },
        { key: 'fecha', description: 'Fecha', type: 'STRING' },
        { key: 'cambio', description: 'Tipo de cambio', type: 'NUMBER' },
    ];

    filterValues: any = {};

    currencyValuesAvailable?: SelectOption[] = [
        { codigo: 'ARS', descripcion: 'Pesos' },
        { codigo: 'USD', descripcion: 'Dolar' },
    ];


    constructor(
        public utilsService: UtilsService,
        private dialog: MatDialog,
        private exchangeRateService: ExchangeRateService,
    ) {}

    ngOnInit(): void {
        this.columns.find(col => col.name === '').template = this.buttonsColumnTeplate;
        this.getExchangeRate();
    }

    compare = (op1: string | undefined, op2:  string | undefined ) => op1 === op2;

    setFilterValues(values: any) {
        this.filterValues = values;
        this.getExchangeRate();
    }

    esEntero(numero: number) {
        let parseValue;
        if (numero % 1 === 0) {
            parseValue = numero + '.00';
        } else {
            parseValue = numero;
        }
        return parseValue;
      }

    getExchangeRate() {
        this.exchangeRateFG.markAllAsTouched();
        if (!this.exchangeRateFG.valid) return
        const values = this.exchangeRateFG.getRawValue();
        this.exchangeRateService.getExchangeRate(this.paginatorStatus.page, this.paginatorStatus.itemsPerPage, this.sortConfiguration ? [this.sortConfiguration] : [], values.codigoMonedaBase, values.codigoMonedaCambio, this.filterValues).subscribe({
            next: response => {
                this.paginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
                this.exchangeRates = response.body;
            },
            error: (error: ErrorResponse) => {
                this.utilsService.alert('Error al obtener los tipos de cambio', error.error.descripcion)
            }
        })
    }

    updateExchangeRate(event: PageEvent) {
        this.paginatorStatus.itemsPerPage = event.pageSize;
        this.paginatorStatus.page = event.pageIndex;
        this.getExchangeRate();
    }

    updateSort(event: SortConfiguration) {
        this.sortConfiguration = event;
        this.getExchangeRate();
    }

    openNewExchangeRateDialog() {
       const data = {
        codigoMonedaBase: this.exchangeRateFG.get('codigoMonedaBase')?.value,
        codigoMonedaCambio: this.exchangeRateFG.get('codigoMonedaCambio')?.value,
       }

        this.dialog.open(NewExchangeRateDialogComponent, { data })
            .afterClosed().subscribe(result => {
                if (result) {
                    this.getExchangeRate();
                }
            });
    }
}
